import { useEffect, useMemo, useState } from "react";

export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "resume_theme";

function getSystemTheme(): ThemeMode {
  if (typeof window === "undefined") return "dark";
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function useTheme() {
  const initial = useMemo<ThemeMode>(() => {
    if (typeof window === "undefined") return "dark";
    const fromStorage = window.localStorage.getItem(STORAGE_KEY);
    if (fromStorage === "light" || fromStorage === "dark") return fromStorage;
    return getSystemTheme();
  }, []);

  const [theme, setThemeState] = useState<ThemeMode>(initial);

  const setTheme = (mode: ThemeMode) => {
    setThemeState(mode);
    window.localStorage.setItem(STORAGE_KEY, mode);
  };

  const toggleTheme = () => setTheme(theme === "dark" ? "light" : "dark");

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", theme === "dark" ? "#0b1220" : "#f8fafc");
  }, [theme]);

  return { theme, setTheme, toggleTheme } as const;
}

